<template>
  <div class="socialResponsibility">
    <div class="head">
      <div class="video">
        <video
          controls="controls"
          poster="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/videoPoster1.jpg"
        >
          <source
            src="//static-oss.qutoutiao.net/socialResponsibility/mp4/character_00.mp4"
            type="video/mp4"
          >
        </video>
      </div>
      <div class="content">
        <div class="logo">
          <img src="//static-oss.qutoutiao.net/socialResponsibility/img/LOGO.png">
        </div>
        <div class="text">
          <p>“家乡代言人”是趣头条长期的正能量计划，趣头条希望通过内容平台和产品、技术的力量，寻找100位“家乡代言人”。</p>
          <p>从个体到群体、从乡村到城市，从离开到反哺，每位离开家乡的人都是为了更好地回到家乡。趣头条基于自身内容生态，连接了人与家乡，让用户可以通过趣头条的产品，为家乡发声，为家乡代言。趣头条将持续赋能“家乡代言人”，打破时间和空间的束缚，打造乡村振兴和文化传承的社会价值体系。</p>
        </div>
      </div>
    </div>
    <div class="hometown">
      <div class="img">
        <img src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/HomeTown.png">
      </div>
      <div class="character1">
        <div class="title">
          <img
            class="triangle"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/tr.png"
          >
          <p>PART</p>
          <img
            class="number"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/01.png"
          >
        </div>
        <div class="content">
          <div class="text">
            <h2 class="name">龙晶睛</h2>
            <p class="subtitle">七进大山</p>
            <p class="subtitle">用行动践行“90后”新公益</p>
            <p class="con">90后海归女大学生龙晶睛，连续7年深入湘西山区支教，陪伴孩子们成长。她希望孩子们能不用走出山区，也能得到所需的一切。</p>
          </div>
          <img
            class="pic"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/character01.png"
          >
          <video
            class="video"
            controls="controls"
            poster="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/videoPoster2.jpg"
          >
            <source
              src="//static-oss.qutoutiao.net/socialResponsibility/mp4/character_01.mp4"
              type="video/mp4"
            >
          </video>
        </div>
      </div>
      <div class="character2">
        <div class="title">
          <img
            class="triangle"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/tr.png"
          >
          <p>PART</p>
          <img
            class="number"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/02.png"
          >
        </div>
        <div class="content">
          <div class="text">
            <h2 class="name">何鑫</h2>
            <p class="subtitle">传承使命</p>
            <p class="subtitle">一家三代保护陕西大熊猫</p>
            <p class="con">“熊猫王子”何鑫，自幼与国宝一起成长，自费万元为国宝庆生，邀全国网友来看陕西大熊猫。何鑫与爷爷、爸爸一家三代传承着保护大熊猫的使命。</p>
          </div>
          <img
            class="pic"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/character02.png"
          >
          <video
            class="video"
            controls="controls"
            poster="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/videoPoster3.jpg"
          >
            <source
              src="//static-oss.qutoutiao.net/socialResponsibility/mp4/character_02.mp4"
              type="video/mp4"
            >
          </video>
        </div>
      </div>
      <div class="character3">
        <div class="title">
          <img
            class="triangle"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/tr.png"
          >
          <p>PART</p>
          <img
            class="number"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/03.png"
          >
        </div>
        <div class="content">
          <div class="text">
            <h2 class="name">姜东</h2>
            <p class="subtitle">绿色创业</p>
            <p class="subtitle">带领全村脱贫致富</p>
            <p class="con">青年姜东返乡创业，“征用”老婆 10万嫁妆，结合秦岭独特的棕榈树资源创办棕榈床垫厂，用绿色环保的模式带领全村致富年入300万。</p>
          </div>
          <img
            class="pic"
            src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/character03.png"
          >
          <video
            class="video"
            controls="controls"
            poster="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/videoPoster4.jpg"
          >
            <source
              src="//static-oss.qutoutiao.net/socialResponsibility/mp4/character_03.mp4"
              type="video/mp4"
            >
          </video>
        </div>
      </div>
    </div>
    <div class="village">
      <div class="img">
        <img src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/Village.png">
      </div>
      <div class="culturalHeritage">
        <img src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/village1.png">
        <div class="content">
          <div class="green"></div>
          <p>文化传承</p>
        </div>
      </div>
      <div class="hometownSpecialty">
        <img src="//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/village2.png">
        <div class="content">
          <div class="green"></div>
          <p>家乡特产</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'socialResponsibility',
    components: {
    },
    data() {
        return {

        };
    },
    methods: {
    },
    mounted() {
    },
};
</script>

<style lang="less">
.socialResponsibility{
    padding-top: 2.21rem;
    width: 100%;
    .head{
        width: 100%;
        height: 518px;
        background: url(//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/Bitmap1.png);
        background-size: cover;
        .video{
            width: 100%;
            height: 39%;
            video{
                width: 100%;
                height: 100%;
                object-fit: fill;
            }
        }
        .content{
            .logo{
                margin: 5% 12.8% 2%;
                height: 6.2%;
                width: 74%;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .text{
                color: white;
                width: 100%;
                height: 100%;
                p{
                    font-family: PingFangSC-Light, sans-serif;
                    font-size: 13px;
                    color: #D4D4D4;
                    margin: 0px 9.6% 3.4% 10.4%;
                    text-indent: 2em;
                }
            }
        }
    }
    .hometown{
        width: 100%;
        .img{
            width: 44%;
            margin: 12% auto 4%;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .character1{
            height: 375px;
            width: 100%;
            padding-left: 4.5%;
            margin-bottom: 8%;
            position: relative;
            .title{
                .triangle{
                    position: absolute;
                    width: 3.2%;
                    height: 2.4%;
                    top: 3.5%;
                    left: 3.5%;
                }
                p{
                    font-size: 24px;
                    color: #EAEAEA;
                    margin-left: 3.5%;
                }
                .number{
                    width: 16%;
                    position: absolute;
                    top: 8px;
                    z-index: -1;
                    left: 24%;
                }
            }
            .content{
                height: 350px;
                width: 60%;
                border: solid #6DD799 3px;
                position: relative;
                .text{
                    margin: 2% 6% 0px 4.8%;
                    font-family: PingFangSC-Light, sans-serif;
                    .name{
                        color: #3BAE60;
                        font-size: 26px;
                        padding-bottom: 1%;
                    }
                    .subtitle{
                        color: #333333;
                        font-size: 13px;
                        font-weight: 600;
                    }
                    .con{
                        color: #444444;
                        font-size: 12px;
                        padding-top: 1%;
                    }
                }
                .pic{
                    position: absolute;
                    height: 126px;
                    width: 126px; 
                    z-index: 1;
                    right: -116px;
                    top: 22px;
                }
                .video{
                    position: absolute;
                    width: 120%;
                    max-height: 42%;
                    object-fit: fill;
                    z-index: 1;
                    bottom: 3%;
                    right: -125px;
                }
            }
        }
        .character2{
            height: 375px;
            width: 100%;
            padding-right: 4.5%;
            margin-bottom: 8%;
            position: relative;
            .title{
                margin-left: 60%;
                .triangle{
                    position: absolute;
                    width: 3.2%;
                    height: 2.4%;
                    top: 3.5%;
                    left: 53%;
                }
                p{
                    font-size: 24px;
                    color: #EAEAEA;
                }
                .number{
                    width: 16%;
                    position: absolute;
                    top: 8px;
                    z-index: -1;
                    left: 73%;
                }
            }
            .content{
                height: 350px;
                width: 60%;
                border: solid #6DD799 3px;
                position: relative;
                float: right;
                .text{
                    position: absolute;
                    bottom: 8px;
                    margin: 0% 2% 2% 4.8%;
                    font-family: PingFangSC-Light, sans-serif;
                    display: flex;
                    flex-direction: column;
                    .name{
                        color: #3BAE60;
                        font-size: 26px;
                        padding-bottom: 1%;
                    }
                    .subtitle{
                        color: #333333;
                        font-size: 13px;
                        font-weight: 600;
                    }
                    .con{
                        color: #444444;
                        font-size: 12px;
                        padding-top: 1%;
                    }
                }
                .pic{
                    position: absolute;
                    height: 126px;
                    width: 126px; 
                    z-index: 1;
                    left: -116px;
                    bottom: 22px;
                }
                .video{
                    position: absolute;
                    width: 120%;
                    max-height: 42%;
                    object-fit: fill;
                    z-index: 1;
                    top: 3%;
                    left: -125px;
                }
            }
        }
        .character3{
            height: 375px;
            width: 100%;
            padding-left: 4.5%;
            margin-bottom: 12%;
            position: relative;
            .title{
                .triangle{
                    position: absolute;
                    width: 3.2%;
                    height: 2.4%;
                    top: 3.5%;
                    left: 3.5%;
                }
                p{
                    font-size: 24px;
                    color: #EAEAEA;
                    margin-left: 3.5%;
                }
                .number{
                    width: 16%;
                    position: absolute;
                    top: 8px;
                    z-index: -1;
                    left: 24%;
                }
            }
            .content{
                height: 350px;
                width: 60%;
                border: solid #6DD799 3px;
                position: relative;
                .text{
                    margin: 2% 6% 0px 4.8%;
                    font-family: PingFangSC-Light, sans-serif;
                    .name{
                        color: #3BAE60;
                        font-size: 26px;
                        padding-bottom: 1%;
                    }
                    .subtitle{
                        color: #333333;
                        font-size: 13px;
                        font-weight: 600;
                    }
                    .con{
                        color: #444444;
                        font-size: 12px;
                        padding-top: 1%;
                    }
                }
                .pic{
                    position: absolute;
                    height: 126px;
                    width: 126px; 
                    z-index: 1;
                    right: -116px;
                    top: 22px;
                }
                .video{
                    position: absolute;
                    width: 120%;
                    max-height: 42%;
                    object-fit: fill;
                    z-index: 1;
                    bottom: 3%;
                    right: -125px;
                }
            }
        }
    }
    .village{
        background-color: black;
        width: 100%;
        height: 820px;
        background: url(//static-oss.qutoutiao.net/mqtoutiao/socialResponsibility/img/Bitmap2.png);
        background-size: cover;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        justify-content: center;
        flex-direction: column;
        .img{
            width: 30%;
            img{
                width: 100%;
            }
        }
        .culturalHeritage{
            width: 91%;
            margin-top: 29px;
            img{
                width: 100%;
            }
            .content{
                background-color: #282828;
                width: 100%;
                height: 59px;
                border-radius: 0px 0px 8px 8px;
                margin-top: -2.5%;
                display: flex;
                align-items: center;
                .green{
                    margin-left: 20px;
                    width: 5px;
                    height: 22px;
                    background-color: #29C981;
                }
                p{
                    margin-left: 15px;
                    color: #FFFFFF;
                    font-family: PingFangSC-Light, sans-serif;
                    font-size: 20px;
                }
            }
        }
        .hometownSpecialty{
            width: 91%;
            margin-top: 29px;
            border-radius: 0px 0px 8px 8px;
            img{
                width: 100%;
            }
            .content{
                background-color: #282828;
                width: 100%;
                height: 59px;
                border-radius: 0px 0px 8px 8px;
                margin-top: -2.5%;
                display: flex;
                align-items: center;
                .green{
                    margin-left: 20px;
                    width: 5px;
                    height: 22px;
                    background-color: #29C981;
                }
                p{
                    margin-left: 15px;
                    color: #FFFFFF;
                    font-family: PingFangSC-Light, sans-serif;
                    font-size: 20px;
                }
            }
        }
    }
}
</style>
